module.exports = __webpack_public_path__ + "img/builder-16.0c111d38.webp";